import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import { SingleSampleAccessPointUIProps } from '../../../util/types';
import styles from './APManagePage.module.less';

const APManagePage: React.FC<SingleSampleAccessPointUIProps> = ({
  cardTypeLabel,
  handleOpenModal,
}) => (
  <Link
    className={styles.apManagementPage}
    arrow
    arrowPosition="postfix"
    onClick={(): void => {
      if (handleOpenModal) {
        handleOpenModal({ entryPoint: 'WEBSITE_MANAGE_PAGE' });
      }
    }}
    role="button"
  >
    Get a Free Matching {cardTypeLabel} Sample
  </Link>
);

export default APManagePage;
